import React from 'react';

/**
 * Card - Container card riutilizzabile
 * 
 * Props:
 * - title: string
 * - subtitle: string
 * - actions: React.ReactNode (pulsanti header)
 * - footer: React.ReactNode
 * - noPadding: boolean
 * - hoverable: boolean
 */
function Card({
  children,
  title,
  subtitle,
  actions,
  footer,
  noPadding = false,
  hoverable = false,
  className = '',
  onClick
}) {
  return (
    <div
      className={`
        bg-white rounded-lg shadow
        ${hoverable ? 'hover:shadow-md transition-shadow cursor-pointer' : ''}
        ${className}
      `}
      onClick={onClick}
    >
      {/* Header */}
      {(title || actions) && (
        <div className="px-6 py-4 border-b flex items-center justify-between">
          <div>
            {title && (
              <h3 className="text-lg font-semibold text-gray-900">{title}</h3>
            )}
            {subtitle && (
              <p className="text-sm text-gray-500 mt-0.5">{subtitle}</p>
            )}
          </div>
          {actions && (
            <div className="flex items-center gap-2">{actions}</div>
          )}
        </div>
      )}

      {/* Content */}
      <div className={noPadding ? '' : 'p-6'}>{children}</div>

      {/* Footer */}
      {footer && (
        <div className="px-6 py-4 border-t bg-gray-50 rounded-b-lg">
          {footer}
        </div>
      )}
    </div>
  );
}

/**
 * StatCard - Card per statistiche
 */
export function StatCard({
  title,
  value,
  subtitle,
  icon,
  trend,
  trendLabel,
  className = ''
}) {
  const trendColors = {
    up: 'text-green-600',
    down: 'text-red-600',
    neutral: 'text-gray-500'
  };

  const trendIcons = {
    up: '↑',
    down: '↓',
    neutral: '→'
  };

  return (
    <div className={`bg-white rounded-lg shadow p-6 ${className}`}>
      <div className="flex items-start justify-between">
        <div>
          <p className="text-sm font-medium text-gray-500">{title}</p>
          <p className="text-2xl font-bold text-gray-900 mt-1">{value}</p>
          {subtitle && (
            <p className="text-sm text-gray-500 mt-1">{subtitle}</p>
          )}
          {trend && (
            <p className={`text-sm mt-2 ${trendColors[trend]}`}>
              {trendIcons[trend]} {trendLabel}
            </p>
          )}
        </div>
        {icon && (
          <div className="p-3 bg-primary-100 rounded-lg text-primary-600">
            {icon}
          </div>
        )}
      </div>
    </div>
  );
}

export default Card;
